import { render, staticRenderFns } from "./vacancies.vue?vue&type=template&id=4f987de4&"
import script from "./vacancies.vue?vue&type=script&lang=js&"
export * from "./vacancies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f987de4')) {
      api.createRecord('4f987de4', component.options)
    } else {
      api.reload('4f987de4', component.options)
    }
    module.hot.accept("./vacancies.vue?vue&type=template&id=4f987de4&", function () {
      api.rerender('4f987de4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/base/vacancies/vacancies.vue"
export default component.exports